import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { UtilService } from '@services/util.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserManagementService } from 'src/app/modules/user-management/services/user-management.service';

@Component({
  selector: 'app-modal-delete-factors',
  templateUrl: './modal-delete-factors.component.html',
  styleUrls: ['./modal-delete-factors.component.scss']
})
export class ModalDeleteFactorsComponent implements OnDestroy {

  private destroyed$: Subject<any> = new Subject();
  public isLoading = false;

  constructor(
    private dialogRef: MatDialogRef<ModalDeleteFactorsComponent>,
    private userManagementService: UserManagementService,
    private utilService: UtilService
  ) { }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  public delete(): void {
    this.isLoading = true;
    this.userManagementService.deleteFactors().pipe(takeUntil(this.destroyed$)).subscribe(
      res => {
        if (res.success) {
          this.closeDialog(true);
        } else {
          this.utilService.toastErrors(res);
        }
        this.isLoading = false;
      },
      error => {
        this.utilService.toastErrors(error);
        this.isLoading = false;
      }
    );
  }

  public closeDialog(deletedSuccess: boolean = false): void {
    this.dialogRef.close(deletedSuccess);
  }

}
